import { Box, Stack, Typography } from '@mui/material'
import { QuestionCircle24Regular } from '@/components/Icon'
import { useClarificationSubmit } from '@/features/chat/clarifications/useClarificationSubmit'
import ClarificationForm from './clarification/ClarificationForm'
import ClarificationSubmittedView from './clarification/ClarificationSubmittedView'

/**
 * The durable form the turn ended on.
 *
 * It is a card and not a Thoughts row on purpose: the tool call that produced it
 * is already a timeline activity, and this is its output. It reaches the server
 * through its own endpoint rather than the composer, so the answers are matched
 * against the persisted question set instead of being re-read out of prose.
 */
export default function ClarificationCardBlock({ block }) {
  const questions = block.questions ?? []
  const { submitted, pending, error, submit } = useClarificationSubmit(block)

  return (
    <Box
      sx={{
        p: 1.75,
        borderRadius: 'var(--app-radius-md)',
        border: 'none',
        bgcolor: 'var(--app-bg-hover)',
        maxWidth: 500,
      }}
    >
      <Stack direction="row" sx={{ gap: 1, alignItems: 'flex-start' }}>
        <Box sx={{ color: 'var(--app-text-secondary)', mt: '1px', display: 'flex' }}>
          <QuestionCircle24Regular fontSize={20} />
        </Box>
        <Stack sx={{ flex: 1, minWidth: 0, gap: 1 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 650 }}>
            {submitted ? 'Answers submitted' : 'A few details are needed'}
          </Typography>
          {submitted ? (
            <ClarificationSubmittedView
              questions={questions}
              answers={block.submitted_answers ?? {}}
            />
          ) : (
            <ClarificationForm
              questions={questions}
              pending={pending}
              error={error}
              onSubmit={submit}
            />
          )}
        </Stack>
      </Stack>
    </Box>
  )
}
